import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { BsSearch, BsCheckCircle, BsCalendar, BsFunnel, BsChevronDown, BsChevronLeft, BsChevronRight } from "react-icons/bs/index.js";
import funciones from '../../../middleware/funciones';
import './nomina.css';

const labelStyle = { fontSize: '0.75rem', fontWeight: '600', color: '#4b5563', marginBottom: '4px' };
const inputStyle = { borderRadius: '6px', border: '1px solid #d1d5db', backgroundColor: 'white' };

const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
// '202609' → 'Sep 2026'
const etiquetaPeriodo = (p) => `${MESES[Number(p.slice(4, 6)) - 1]} ${p.slice(0, 4)}`;

const SearchFilters = ({
  filters,
  onFilterChange,
  periodos,
  periodosConNomina,
  onSelectPeriodo,
  onSearch,
  onMassiveApprove,
  approving,
  selectedItems,
  searchFilters,
  onSearchChange,
  children
}) => {
  const [masFiltros, setMasFiltros] = useState(false);
  const [verPeriodos, setVerPeriodos] = useState(false);
  const [anio, setAnio] = useState('');
  const menuRef = useRef(null);

  // Cierra la lista de periodos al hacer clic fuera
  useEffect(() => {
    if (!verPeriodos) return undefined;
    const cerrar = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setVerPeriodos(false); };
    document.addEventListener('mousedown', cerrar);
    return () => document.removeEventListener('mousedown', cerrar);
  }, [verPeriodos]);

  const visibles = periodos || [];
  const conNomina = periodosConNomina || [];
  // Años con nómina (ascendente); se muestran hasta 3 pestañas alrededor del año abierto
  const anios = conNomina.map((p) => p.slice(0, 4)).filter((a, i, arr) => arr.indexOf(a) === i).sort();
  const iAnio = anios.indexOf(anio);
  const inicio = Math.max(0, Math.min(iAnio - 1, anios.length - 3));
  const pestanas = anios.slice(inicio, inicio + 3);

  const abrirPeriodos = () => {
    if (!verPeriodos) setAnio((filters.periodo || conNomina[0] || '').slice(0, 4));
    setVerPeriodos(!verPeriodos);
  };
  // Un periodo elegido desde "…" se muestra como chip activo junto a los recientes
  const extra = filters.periodo && visibles.indexOf(filters.periodo) === -1 ? filters.periodo : null;

  const chip = (p) => (
    <button
      key={p}
      type="button"
      className={'nom-chip' + (filters.periodo === p ? ' active' : '')}
      onClick={() => onSelectPeriodo(p)}
      aria-pressed={filters.periodo === p}
      title={p}
    >
      {etiquetaPeriodo(p)}
    </button>
  );

  // Al usar fechas se deja de filtrar por periodo
  const cambiarFecha = (campo, valor) => {
    onFilterChange(campo, valor);
    if (filters.periodo) onFilterChange('periodo', '');
  };

  const sinSeleccion = !selectedItems || selectedItems.length === 0;
  // El backend acepta filtros parciales; sin ninguno traería todas las nóminas de la empresa
  const hayFiltroServidor = !!filters && !!(filters.periodo || filters.fecha_inicial || filters.fecha_final || filters.numero_inicial || filters.numero_final);

  return (
    <div className="dt-filters-panel" style={{ padding: '16px 20px', background: '#ffffff', borderRadius: '16px' }}>
      <div className="nom-filtros-header">
        <div className="nom-chips">
          <span className="nom-chips-label">Periodo:</span>

          <div className="nom-mas-periodos" ref={menuRef}>
            <button
              type="button"
              className={'nom-chip nom-chip-otros' + (verPeriodos ? ' open' : '')}
              onClick={abrirPeriodos}
              aria-expanded={verPeriodos}
              disabled={conNomina.length === 0}
            >
              <BsCalendar /> Otros
            </button>
            {verPeriodos && (
              <div className="nom-meses-panel" role="dialog" aria-label="Elegir periodo">
                <div className="nom-anios">
                  <button type="button" className="nom-anio-flecha" aria-label="Año anterior"
                    disabled={iAnio <= 0} onClick={() => setAnio(anios[iAnio - 1])}>
                    <BsChevronLeft />
                  </button>
                  <div className="nom-anios-lista">
                    {pestanas.map((a) => (
                      <button key={a} type="button" className={'nom-anio' + (a === anio ? ' active' : '')} onClick={() => setAnio(a)}>
                        {a}
                      </button>
                    ))}
                  </div>
                  <button type="button" className="nom-anio-flecha" aria-label="Año siguiente"
                    disabled={iAnio === -1 || iAnio >= anios.length - 1} onClick={() => setAnio(anios[iAnio + 1])}>
                    <BsChevronRight />
                  </button>
                </div>
                <div className="nom-meses">
                  {MESES.map((m, i) => {
                    const p = `${anio}${String(i + 1).padStart(2, '0')}`;
                    return (
                      <button
                        key={p}
                        type="button"
                        className={'nom-mes' + (filters.periodo === p ? ' active' : '')}
                        disabled={conNomina.indexOf(p) === -1}
                        onClick={() => { onSelectPeriodo(p); setVerPeriodos(false); }}
                        aria-pressed={filters.periodo === p}
                      >
                        {m}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {extra && chip(extra)}
          {visibles.map(chip)}
        </div>

        <div className="nom-filtros-acciones">
          <button
            type="button"
            className={'nom-btn-mas-filtros' + (masFiltros ? ' open' : '')}
            onClick={() => setMasFiltros(!masFiltros)}
            aria-expanded={masFiltros}
            aria-controls="nom-panel-filtros"
          >
            <BsFunnel /> Más filtros <BsChevronDown className="nom-chevron" />
          </button>
          <button
            type="button"
            className="nom-btn-aprobar"
            onClick={(e) => { e.preventDefault(); onMassiveApprove(e); }}
            disabled={sinSeleccion || approving}
          >
            <BsCheckCircle className="me-2" size={15} style={{ strokeWidth: '0.5' }} />
            Aprobar Seleccionados ({selectedItems ? selectedItems.length : 0})
          </button>
        </div>
      </div>

      {/* Panel deslizable con el resto de filtros */}
      <div id="nom-panel-filtros" className={'nom-panel' + (masFiltros ? ' abierto' : '')} aria-hidden={!masFiltros}>
        <Form onSubmit={(e) => { e.preventDefault(); onSearch(e); }}>
          <Row className="g-2 align-items-end">
            <Col xs={12} sm={6} md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Fecha Inicio</Form.Label>
                <Form.Control type="date" size="sm" style={inputStyle}
                  value={funciones.formatDate(filters.fecha_inicial)}
                  onChange={(e) => cambiarFecha('fecha_inicial', e.target.value)} />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Fecha Fin</Form.Label>
                <Form.Control type="date" size="sm" style={inputStyle}
                  value={funciones.formatDate(filters.fecha_final)}
                  onChange={(e) => cambiarFecha('fecha_final', e.target.value)} />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Número Inicial</Form.Label>
                <Form.Control type="number" size="sm" style={inputStyle}
                  value={filters.numero_inicial}
                  onChange={(e) => onFilterChange('numero_inicial', e.target.value)} />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Número Final</Form.Label>
                <Form.Control type="number" size="sm" style={inputStyle}
                  value={filters.numero_final}
                  onChange={(e) => onFilterChange('numero_final', e.target.value)} />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Tipo</Form.Label>
                <Form.Control type="text" size="sm" maxLength="4" name="searchTipo" style={inputStyle}
                  value={(searchFilters && searchFilters.searchTipo) || ''} onChange={onSearchChange} />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Cliente</Form.Label>
                <Form.Control type="text" size="sm" maxLength="20" name="searchCliente" style={inputStyle}
                  value={(searchFilters && searchFilters.searchCliente) || ''} onChange={onSearchChange} />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Transacción</Form.Label>
                <Form.Control type="text" size="sm" maxLength="9" name="searchTransaccion" style={inputStyle}
                  value={(searchFilters && searchFilters.searchTransaccion) || ''} onChange={onSearchChange} />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <button
                type="submit"
                className="dt-btn-create"
                disabled={!hayFiltroServidor}
                style={{ width: '100%', justifyContent: 'center' }}
              >
                <BsSearch className="me-2" size={15} /> Buscar
              </button>
            </Col>
          </Row>
        </Form>
      </div>

      {/* Avance del periodo (ProgresoPeriodo), dentro de la misma tarjeta */}
      {children}
    </div>
  );
};

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/components/nomina/components/SearchFilters.jsx